<template>
    <div class="loading-icon" :class="[ size ? `loading-${size}` : '' ]"></div>
</template>

<script>
export default {
    props: {
        size: {
            type: String,
            default: null,
        }
    },
}
</script>
